import React from "react";
import { log } from '@/lib/utils/logger';

interface GlobalFooterProps {
  component?: {
    details?: {
      title?: string;
    };
  };
}

// Global Footer Component Renderer
const GlobalFooterRenderer: React.FC<GlobalFooterProps> = ({ component }) => {
  const title = component?.details?.title || 'Straight Talk Net10 Clearway Total Wireless TracFone SimpleMobile SafeLink WalmartFamilyMobile';

  log.debug('GlobalFooterRenderer rendering with title:', title);

  return (
    <footer className="w-full bg-gradient-to-r from-gray-100 to-gray-200 border-t-2 border-gray-400 py-8 px-4 block" style={{ minHeight: '120px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <p className="text-sm text-gray-800 font-semibold leading-relaxed break-words">
            {title}
          </p>
          <p className="text-xs text-gray-600 mt-4">
            © 2025 Verizon. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooterRenderer;